<template>
   <div class="tax-information-bubble">
      <div class="tax-information-header">{{ $t(title) }}</div>
      <ul class="tax-information-list">
         <span class="tax-information-header">{{ $t("taxInformation_includedTaxes") }}</span>
         <li v-for="(tax, index) in includedTaxes" :key="'included-' + index">
            <span>{{ $t(tax.amount) | price(tax.currency) }}</span>
            {{ $t(`taxInformation_${tax.name}`) }}
         </li>
         <span class="tax-information-header">{{ $t("taxInformation_excludedTaxes") }}</span>
         <li v-for="(tax, index) in excludedTaxes" :key="'excluded-' + index">
            <span>{{ $t(tax.amount) | price(tax.currency) }}</span>
            {{ $t(`taxInformation_${tax.name}`) }}
         </li>
      </ul>
   </div>
</template>

<script>
export default {
   name: "TaxInfoModal",
   props: {
      title: { type: String },
      taxInformation: { type: Object },
   },
   data() {
      return {};
   },
   computed: {
      includedTaxes() {
         return this.taxInformation.filter((tax) => tax.includedBySupplier);
      },
      excludedTaxes() {
         return this.taxInformation.filter((tax) => !tax.includedBySupplier);
      },
   },
   created() {},
   methods: {},
};
</script>

<style lang="scss" scoped>
.tax-information-bubble {
   position: absolute;
   top: 0;
   right: 0;
   z-index: 1000;
   background-color: var(--gray-700);
   //color: var(--gray-50);
   color: var(--gray-0);
   width: 230px;
   padding: 1rem;
   border-radius: 8px;
}

.tax-information-bubble::before {
   content: "";
   position: absolute;
   top: 10px;
   right: -10px;
   translate: -50% -75%;
   rotate: -90deg;
   width: 0;
   height: 0;
   border-top: 10px solid transparent;
   border-bottom: 10px solid transparent;
   border-right: 10px solid var(--gray-700);
}

.tax-information-header {
   font-weight: bold;
   margin-bottom: 0.75rem;
   font-size: 1rem;
}

.tax-information-list {
   list-style-type: none;
   margin: 0;
   padding: 0;
}

.tax-information-list li {
   display: flex;
   justify-content: space-between;
   margin-bottom: 0.5rem;
   font-size: 0.875rem;
}

.tax-information-list li span {
   font-weight: bold;
}
</style>
